import { useMemo, useState } from 'react';

import { Popover, PopoverContent } from '@mint-lib/tw-components';

import {
  AddRowDataContext,
  type AddRowData,
} from '../../../../../../hooks/useAddRowDataContext.js';
import AddRowInside from '../AddRowInside/AddRowInside.jsx';

type AddRowProviderProps = {
  children: React.ReactNode;
};

export const AddRowProvider = ({ children }: AddRowProviderProps) => {
  const [addRowData, setAddRowData] = useState<AddRowData | null>(null);

  const addRowDataContextValue = useMemo(
    () => ({
      mediaDataId: addRowData?.mediaData.id,
      setAddRowData,
    }),
    [addRowData],
  );

  return (
    <AddRowDataContext.Provider value={addRowDataContextValue}>
      <Popover open={!!addRowData} onOpenChange={() => setAddRowData(null)}>
        {children}
        <PopoverContent className="z-popover w-74 px-0 py-1" align="end">
          {addRowData?.mediaData && (
            <AddRowInside
              mediaData={addRowData.mediaData}
              closeMenu={() => setAddRowData(null)}
              api={addRowData.api}
            />
          )}
        </PopoverContent>
      </Popover>
    </AddRowDataContext.Provider>
  );
};
